import type { Cage, Transit } from '../index.h'

import { createEvent, sample, split } from 'effector'
import { model as session } from '~/entities/session'
import { appearanceFeature } from '~/features/appearance'
import { model as guest } from '~/features/subscriber/guest'
import { F, T } from '~/shared/helpers'
import { keys } from '~/shared/jail'

/*
 * ### Appearance cage ###
 */

const init = createEvent<Transit>('init')
const seal = createEvent<boolean>('seal')

// out events
const gotoApp = createEvent('gotoApp')
const gotoGuest = createEvent('gotoGuest')

export const appearance = {
  name: 'appearance',
  key: keys.lost,
  init,
  seal,
  in: [],
  out: {
    gotoApp,
    gotoGuest,
  },
} satisfies Cage

/*
 * cage logic
 */

const out = createEvent()

sample({
  clock: init,
  target: seal.prepend(T),
})

sample({
  clock: init,
  target: appearanceFeature.init,
})

sample({
  source: appearanceFeature.$ready,
  filter: Boolean,
  target: out,
})

split({
  clock: out,
  source: guest.$guest,
  match: (isGuest) => (isGuest ? 'gotoGuest' : 'gotoApp'),
  cases: {
    gotoApp,
    gotoGuest,
  },
})

sample({
  clock: [gotoApp, gotoGuest],
  target: seal.prepend(F),
})

sample({
  clock: gotoGuest,
  target: session.stopGuestReloginTransition,
})
